import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { Reveal } from "@/components/primitives";

const METRICS = [
  { value: 500, suffix: "+", label: "Projects Completed" },
  { value: 30, suffix: " Million+", label: "Sq. Ft. of Completed Projects", smallSuffix: true },
  { value: 50, suffix: "+", label: "Years Combined Experience" },
  { value: 160, suffix: "+", label: "Team Members" },
];

function useCountUp(target, active, duration = 1700) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      setVal(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [active, target, duration]);
  return val;
}

function Metric({ value, suffix, label, active, index, smallSuffix }) {
  const v = useCountUp(value, active);
  return (
    <div
      className="flex flex-col gap-3 border-l border-paper/15 py-10 pl-6 lg:pl-10"
      data-testid={`credential-metric-${index + 1}`}
    >
      <span className="font-serif text-5xl text-paper lg:text-7xl">
        {v.toLocaleString("en-IN")}
        <span
          className={`text-maroon ${smallSuffix ? "text-[0.4em]" : ""}`}
          style={{ color: "#C8554F" }}
        >
          {suffix}
        </span>
      </span>
      <span className="text-[11px] font-medium uppercase tracking-[0.25em] text-paper/60">{label}</span>
    </div>
  );
}

export default function Credentials() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section ref={ref} className="grain relative bg-ink px-6 py-24 lg:px-12 lg:py-32" data-testid="credentials-section">
      <div className="relative z-10 mx-auto max-w-[1440px]">
        <Reveal>
          <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-paper/60">
            <span className="text-maroon" style={{ color: "#C8554F" }}>04</span> · Credentials
          </p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 gap-x-8 sm:grid-cols-2 lg:grid-cols-4">
          {METRICS.map((m, i) => (
            <Metric key={m.label} {...m} active={inView} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
